import {
  BulletinApiRequest,
  UpdateBulletinRequest,
} from '@/data/payload/api/BulletinRequest'
import {
  PostBulletinInterface,
  DeleteBulletinInterface,
  UpdateBulletinInterface,
} from '@/data/payload/contracts/BulletinRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { BulletinDataMapper } from '@/data/persistences/mappers/BulletinDataMapper'
import { BulletinRepositoryInterface } from '@/data/persistences/repositories/contracts/BulletinRepositoryInterface'
import { Bulletin } from '@/domain/entities/Bulletin'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class BulletinApiRepository implements BulletinRepositoryInterface {
  private service: ApiService
  private mapper: BulletinDataMapper

  constructor(service: ApiService, mapper: BulletinDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(payload: DeleteBulletinInterface): Promise<Bulletin> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.MATERIAL_BULLETIN_DELETE,
      undefined,
      payload as BulletinApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(payload: PostBulletinInterface): Promise<Bulletin> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.MATERIAL_BULLETIN,
      undefined,
      payload as BulletinApiRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateBulletinInterface,
    id: number
  ): Promise<Bulletin> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.MATERIAL_BULLETIN}/${id}`,
      undefined,
      payload as UpdateBulletinRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<Bulletin> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.MATERIAL_BULLETIN,
      params
    )
    return this.mapper.convertFromApi(resp)
  }
}
